<template>
  <div class="relative">
  <div class="material-master-edit s">
    <div class="grid-2 mt-2">
      <div class="input-group imp" data-validation="CustomMaterialId">
        <label v-if="materialMasterTemp.type == materialTypeIdMap.material" class="key">Material Id:</label>
        <label v-else class="key">Resource Id:</label>
        <input type="text" v-model="materialMasterTemp.custom_material_id" :disabled="true" />
      </div>
      <div class="input-group imp" data-validation="CustomMaterialName">
        <label v-if="materialMasterTemp.type == materialTypeIdMap.material" class="key">Material Name:</label>
        <label v-else class="key">Resource Name:</label>
        <input type="text" v-model="materialMasterTemp.material_name" />
      </div>
    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="grid-2 mt-2">
      <div class="input-group imp" data-validation="UnitOfMaterial">
        <label class="key">Unit Of {{ materialMasterTemp.type == materialTypeIdMap.material ?  'Material' : 'Resource'}}:</label>
        <custom-dropdown
          :list="unitOfMaterialOptions"
          :selected="selectedUnitOfMaterial"
          :disabled="materialMasterTemp.type == materialTypeIdMap.resource"
          :enableSearch="true"
          @select="handleDropdownSelection('unit_of_material', $event)"
          @deselect="handleDropdownSelection('unit_of_material', null)"
        />
      </div>
      <div class="input-group " data-validation="PlmMaterialId">
        <label class="key">PLM {{ materialMasterTemp.type == materialTypeIdMap.material ?  'Material' : 'Resource'}} Id:</label>
        <input type="text" v-model="materialMasterTemp.plm_material_id" :disabled="disabledFields.includes('plm_material_id')"/>
      </div>
    </div>
    <div v-if="view !== 'resource'" class="mt-2" :class="view !== 'material' || showProductCodePreview ? '' : 'grid-2'">
      <div v-if="hasExistingProductCode" class="input-group">
        <label class="key">Product Code:</label>
        <input type="text" v-model="materialMasterTemp.productCodeName" :disabled="true"/>
      </div>
      <div v-else>
        <part-id-preview
          ref="productCodePartIdPreview"
          :disabled="!productCode"
          :showToggle="true"
          :showTemplateSelector="true"
          :featureId="config.CORE_FEATURES.PRODUCT_CODE"
          title="Product Code Preview"
          @sequenceIdSelected="handleSequenceIdSelectionForProductCode"
          @togglePartIdGeneration="handleTogglePartIdGenerationForProductCode"
          @update="updatePartIdValuesForProductCode"
        />
      </div>
      <div class="input-group imp" v-if="materialMasterTemp.type == materialTypeIdMap.material">
        <label class="key">Type:</label>
        <custom-dropdown
          :list="customListType"
          :selected="selectedMaterialType"
          :disabled="true"
          :enableSearch="true"
          @select="handleDropdownSelection('material_type', $event)"
          @deselect="handleDropdownSelection('material_type', null)"
        />
      </div>
    </div>
    <div v-if="moreInput">
    <div class="input-group mt-2">
      <label class="key">{{ materialMasterTemp.type == materialTypeIdMap.material ?  'Material' : 'Resource'}} Description:</label>
      <textarea type="text" v-model="materialMasterTemp.material_description"/>
    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="input-group mt-2">
      <label class="key">Workflow:</label>
       <custom-dropdown
         :disabled="materialMasterTemp.material_type === materialType.Buy"
         :list="workflows"
         :selected="selectedWorkFlow"
         :enableSearch="true"
         :isLoading="WFTLoading"
         @select="handleWorkFlowSelection"
         @deselect="handleWorkFlowSelection(null)"
         class="form-template-container-wft"
       >
         <template #before-items>
           <div class="fh center py-4" v-if="WFTLoading && workflows.length === 0">
             <loading-circle />
           </div>
           <div class="fh center py-4" v-else-if="!WFTLoading && workflows.length === 0">
             No Workflow Templates
           </div>
         </template>
       </custom-dropdown>
    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="grid-2 mt-2">
  <div class="input-group">
    <label class="key">PLM Record Id:</label>
    <input type="text" disabled v-model="materialMasterTemp.plm_record_id" />
  </div>

  <div class="input-group">
    <label class="key">ERP Material Id:</label>
    <input
      type="text"
      v-model="materialMasterTemp.erp_material_id"
      :disabled="disabledFields.includes('erp_material_id')"
    />
  </div>
</div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="input-group mt-2">
      <label class="key">Material Group:</label>
      <custom-dropdown
        :list="list_of_material_group"
        :selected="selectedMaterialGroup"
        :enableSearch="true"
        @select="handleDropdownSelection('material_group', $event)"
        @deselect="handleDropdownSelection('material_group', null)"
      />
    </div>
    <div v-else class="grid-2 mt-2">
      <div class="input-group mt-2">
        <label class="key">Resource Type:</label>
        <custom-dropdown
          :list="list_of_material_group"
          :selected="selectedResourceType"
          :disabled="true"
          :enableSearch="true"
          @select="handleDropdownSelection('resource_type', $event)"
          @deselect="handleDropdownSelection('resource_type', null)"
        />
      </div>
      <div v-if="materialMasterTemp.type == materialTypeIdMap.resource" class="input-group mt-2">
        <label class="key">Setup Time:</label>
        <div class="grid-2">
        <input
          type="number"
          min="0"
          v-model.number="materialMasterTemp.setup_time"
          placeholder="Value"
          @keydown="changeNumber"
        />

        <custom-dropdown
          :list="setupTimeDurationOptions"
          :selected="selectedSetupTimeDuration"
          :enableSearch="true"
          @select="handleDropdownSelection('setup_time_duration_type', $event)"
          @deselect="handleDropdownSelection('setup_time_duration_type', null)"
        />
        </div>
      </div>

    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="grid-2 mt-2">
      <div class="input-group" data-validation="GrossWeight">
        <label class="key">Gross Weight:</label>
        <input type="number" v-model="materialMasterTemp.gross_weight" :disabled="disabledFields.includes('gross_weight')" @keydown="changeNumber"/>
      </div>
      <div class="input-group">
        <label class="key">Weight Unit:</label>
        <custom-dropdown
          :list="list_of_weight_unit"
          :selected="selectedWeightUnit"
          :enableSearch="true"
          @select="handleDropdownSelection('weight_unit', $event)"
          @deselect="handleDropdownSelection('weight_unit', null)"
        />
      </div>
    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="grid-2 mt-2">
      <div class="input-group" data-validation="UnitCost">
        <label class="key">Unit Cost:</label>
        <input type="number" v-model.number="materialMasterTemp.unit_cost" @keydown="changeNumber"/>
      </div>
      <div class="input-group" data-validation="UnitSalePrice">
        <label class="key">Unit Sale Price:</label>
        <input type="number" v-model.number="materialMasterTemp.unit_sale_price" @keydown="changeNumber"/>
      </div>
    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="mt-2 grid-2">
      <effective-date :date="materialMasterTemp.effective_date" @date-selected="materialMasterTemp.effective_date=$event"/>
      <div class="input-group">
        <label class="key">Storage Loc:</label>
        <custom-dropdown
          :list="list_of_address_location"
          :selected="selectedStorageLocation"
          :enableSearch="true"
          defaultLabel="Select"
          @select="handleDropdownSelection('storage_loc', $event)"
          @deselect="handleDropdownSelection('storage_loc', null)"
        />
      </div>
    </div>
    <div v-if="materialMasterTemp.type == materialTypeIdMap.material" class="grid-2 mt-2">
      <!-- <div class="input-group">
        <label class="key">Lead Time:</label>
        <input type="number" v-model.number="materialMasterTemp.lead_time" @keydown="changeNumber"/>
      </div> -->
    </div>
    <div class="grid-1 mt-2">
      <div>
        <label class="key"  >Tags</label>
        <tagInput ref="tagSelector" title="Add tags to material"  :type="1"  :allowMultipleRoots="true" :lastParentId="tagGroupData?.tagArray[selected_tag_line]?.at(-1)?.id" @addNewTag="addnewTag" :tagGroupData="tagGroupData" @parentLevelSelected="changeSelectedTagLine" @resetSelectedLine="resetSelectedTagLine" @focusTagLevel="focusTagLevel"/>
      </div>
    </div>
    <div class="grid-1 mt-2">
      <div>
        <label class="key" >
        Attach Documents</label>
        <div class="document-attach" >
          <div v-if="materialMasterTemp.material_document_associations?.length > 0 " class="weight-500 document-attach-view input-group imp " >
            <div v-for="file in materialMasterTemp.material_document_associations" :key="file.id">
            <div v-show="file.flag!=='deleted'" class="document-attach-list" v-overflow-tooltip>{{ getAttachmentDocName(file) }}</div>
              </div>
          </div>
          <div v-tooltip="' Link Documents '" class="document-attach-edit" @click="documentSelectDialog = true"> <img src="~@/assets/images/icons/file-icon.svg" width="10px" height="10px" alt="" >
          </div>
          </div>      </div>
    </div>
  </div>
  <div class="input-group mt-3" v-show="moreInput && materialMasterTemp.type == materialTypeIdMap.material">
      <label>{{ formTemplateData.name }}</label>
    </div>
    <div class="view-form" v-if="templateField.length && materialMasterTemp.type == materialTypeIdMap.material && moreInput">
    <div class="form-grid mt-2">
  <template v-for="(ele, index) in templateField">
  <div  :key="index" v-if="!ele.autogenerated" :class="['form-grid__item','form-grid__item--span-2']" >
    <component
      :ref="ele.field_id"
      :is="ele.form_field.key + '_COMPONENT'"
      :data="ele"
      :mode="'EDIT'"
      :value="Object.prototype.hasOwnProperty.call(formValueData, ele.field_id) ? formValueData[ele.field_id] : null"
      :viewOnly="formValueData[ele.field_id] ? false : undefined"
      @customChange= "handleInputChange"
      :formData="formData"
      :formTemplate="true"
      :templateId="formTemplateData.id"
    />
  </div>
  </template>
</div>
    </div>
  <div class="mt-2 m underline pointer" @click="toggleMore">
    <span v-if="moreInput">
      Show less
    </span>
    <span v-else>
      Add More Details
    </span>
  </div>

    <modal
    :open="documentSelectDialog"
    @close="documentSelectDialog = false"
    :closeOnOutsideClick="true"
    title=""
    >
    <document-selector @close="documentSelectDialog = false" :restrictUpload="true" @files-selected="handleFileSelection" v-if="documentSelectDialog"  :linkedDocs="[...materialMasterTemp.material_document_associations]" :material-attachment="true"/>
  </modal>
  </div>
  <div class="flex flex-end py-3 l sticky">
      <button class="btn btn-cancel mr-3 pointer" @click="$emit('close')">CANCEL</button>
      <button class="btn pointer" @click="save" :disabled="isSaving">{{ isSaving ? 'SAVING...' : 'SAVE' }}</button>
    </div>
</div>
</template>

<script>
import {
  UpdateMaterialMasterData,
  AddMaterialTags,
  DeleteMaterialTagsByTagIds,
  CreateLinkProductCode,
  UnitOfMaterial,
  WeightUnit,
  AddressLocation,
  attachDocToMaterail,
  removeAttachments,
  ResourceGroup,
  getDetailFormTemplate,
  SaveFormData,
  upadateMaterialForms,
  GetFormDataByFormId,
  GetSingleMaterialMasterData,
  EditForm,
  getFullWorkFLowTemplates,
  checkForAnyRunningInstances,
  getTenantDefaults,
  GetMaterialCustomList,
  getGivenCustomListsData,
  getResourceTypes
} from '@/api'
import config from '../../config'
import { GetFormValueMap } from '@/helper/formValue.js'
import { alert, success } from '@/plugins/notification'
import Loader from '@/plugins/loader'
import TagInput from '../common/tagAndConfigListInput.vue'
import Modal from '../common/modal.vue'
import { mapGetters } from 'vuex'
import effectiveDate from '../../components/common/effectiveDate.vue'
import MaterialMasterValidation from '@/helper/formValidation/materialMaster.js'
import DocumentSelector from '../document/documentSelectorDialog.vue'
import { TagTrie } from '@/utils/tagsHelper'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import LoadingCircle from '../common/loadingCircle.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import tableTemplate from '../../views/SETTINGS/tableTemplate.vue'
import customDropdown from '../common/customDropdown.vue'
import partIdPreview from '../common/partIdPreview.vue'
import { restrictKeys } from '@/utils/validations'
import { GetTenantConfigTypes } from '@/api/apis/tenantConfigFeature'
export default {
  name: 'material-master-edit',
  components: {
    TagInput,
    effectiveDate,
    DocumentSelector,
    Modal,
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    TABLE_COMPONENT: tableTemplate,
    customDropdown,
    partIdPreview,
    LoadingCircle
  },
  props: {
    materialMaster: {
      type: Object,
      default: () => ({})
    },
    resourceState: {
      type: Object,
      default: () => ({})
    },
    view: {
      type: String
    }
  },
  data () {
    return {
      config,
      productCodeFeatureSeq: null,
      sequenceIdForProductCode: null,
      partIdValuesForProductCode: [],
      WFTLoading: true,
      workflows: [],
      materialTypeIdMap: {
        material: 1,
        resource: 2
      },
      materialType: {},
      resourceUnit: {},
      documentSelectDialog: false,
      productCode: false,
      addProduct: false,
      productCodeName: '',
      selectedDate: null,
      parentProductCode: null,
      materialMasterTemp: {},
      productCodeList: [],
      moreInput: false,
      disabledFields: [],
      list_of_unit_of_material: [],
      list_of_weight_unit: [],
      list_of_material_group: [],
      list_of_resource_group: [],
      list_of_address_location: [],
      attachedTags: [],
      selectedTags: [],
      deleteSelectedTags: [],
      tagGroupData: {
        firstLevelParents: [],
        tagArray: []
      },
      hoverd_tag: {
        cindex: null,
        index: null
      },
      selected_tag_line: 0,
      tagTrie: new TagTrie(),
      lastParentId: null,
      window: window,
      buttonDisabled: false,
      templateId: '',
      formTemplateData: {},
      formValueData: {},
      metadataPayloadValueMap: {},
      selectedWorkFlow: null,
      setupTimeDurationOptions: [
        { id: 3, name: 'Minutes' },
        { id: 2, name: 'Hours' },
        { id: 1, name: 'Days' }
      ],
      customListType: [],
      formData: {},
      validationErrors: '', // this is for getting valiadtion errors
      loading: false,
      isSaving: false
    }
  },
  computed: {
    ...mapGetters('tag', ['getTags']),
    ...mapGetters(['isBeaconAdmin', 'isTenantAdmin', 'isOnProjectLevel', 'tenantDefaultsData', 'user']),
    unitOfMaterialOptions () {
      if (this.materialMasterTemp.type === this.materialTypeIdMap.resource) {
        return this.resourceUnit?.id ? [this.resourceUnit] : []
      }
      return this.list_of_unit_of_material
    },
    selectedUnitOfMaterial () {
      return this.findSelectedOption(this.unitOfMaterialOptions, this.materialMasterTemp.unit_of_material)
    },
    selectedMaterialType () {
      return this.findSelectedOption(this.customListType, this.materialMasterTemp.material_type)
    },
    selectedMaterialGroup () {
      return this.findSelectedOption(this.list_of_material_group, this.materialMasterTemp.material_group)
    },
    selectedResourceType () {
      return this.findSelectedOption(this.list_of_material_group, this.materialMasterTemp.resource_type)
    },
    selectedSetupTimeDuration () {
      return this.findSelectedOption(this.setupTimeDurationOptions, this.materialMasterTemp.setup_time_duration_type)
    },
    selectedWeightUnit () {
      return this.findSelectedOption(this.list_of_weight_unit, this.materialMasterTemp.weight_unit)
    },
    selectedStorageLocation () {
      return this.findSelectedOption(this.list_of_address_location, this.materialMasterTemp.storage_loc)
    },
    hasExistingProductCode () {
      return Boolean(this.materialMasterTemp.material_product_code?.product_code)
    },
    showProductCodePreview () {
      return this.view !== 'resource' && !this.hasExistingProductCode
    },
    templateField () {
      if (this.formTemplateData && this.formTemplateData.template_versions) {
        const activeVersion =
        this.formTemplateData.template_versions.find((item) => item.active) ||
        {}
        return activeVersion.template_fields || []
      }
      return []
    }
  },
  methods: {
    getCurrentUserData () {
      return {
        id: this.user?.userId,
        first_name: this.user?.first_name || '',
        last_name: this.user?.last_name || '',
        email: this.user?.email || '',
        phone: this.user?.phone || '',
        status: this.user?.status
      }
    },
    handleTogglePartIdGenerationForProductCode () {
      this.productCode = !this.productCode
      if (this.productCode) {
        this.initializeProductCodePreview()
      }
    },
    handleSequenceIdSelectionForProductCode (id) {
      this.sequenceIdForProductCode = id
    },
    updatePartIdValuesForProductCode (values) {
      this.partIdValuesForProductCode = values
      this.materialMasterTemp.productCodeName = values
        .map(value => `${value.displayValue || ''}${value.delimiter || ''}`)
        .join('')
    },
    initializeProductCodePreview () {
      if (!this.showProductCodePreview || !this.productCodeFeatureSeq || !this.productCode) return
      this.$nextTick(() => {
        const previewRef = this.$refs.productCodePartIdPreview
        if (previewRef?.selectSequenceTemplateById) {
          previewRef.selectSequenceTemplateById(this.productCodeFeatureSeq)
        }
      })
    },
    getProductCodeSequenceInput () {
      if (!this.showProductCodePreview || !this.productCode || !this.sequenceIdForProductCode) return null
      if (!Array.isArray(this.partIdValuesForProductCode) || !this.partIdValuesForProductCode.length) return null
      const hasIncompleteValue = this.partIdValuesForProductCode.some(value => value.value === null || value.value === undefined || value.value === '')
      if (hasIncompleteValue) return null
      return this.partIdValuesForProductCode.map(value => ({
        sequence: value.sequence,
        value: value.value,
        delimiter: value.delimiter
      }))
    },
    findSelectedOption (list = [], id) {
      return list.find(item => item.id === id) || null
    },
    handleDropdownSelection (field, item) {
      this.materialMasterTemp[field] = item?.id ?? null
    },
    getAttachmentDocument (attachment) {
      return attachment?.core_document_version || attachment?.core_document || attachment || {}
    },
    getAttachmentDocName (attachment) {
      const doc = this.getAttachmentDocument(attachment)
      return doc?.doc_name || '--'
    },
    getAttachmentDocumentId (attachment) {
      const doc = this.getAttachmentDocument(attachment)
      return attachment?.document_id || doc?.id || attachment?.id
    },
    getLatestVersion (versions = []) {
      if (!Array.isArray(versions) || !versions.length) {
        return null
      }
      const versionsWithDate = versions.filter(version => version?.created_on)
      if (versionsWithDate.length) {
        return versionsWithDate.reduce((latest, current) => {
          return new Date(current.created_on) > new Date(latest.created_on) ? current : latest
        })
      }
      return versions[0]
    },
    getAttachmentVersionId (attachment) {
      const doc = this.getAttachmentDocument(attachment)
      const docVersions = attachment?.associated_versions || attachment?.core_document?.associated_versions || []
      return attachment?.version_id ||
        attachment?.document_version?.id ||
        attachment?.core_document_version?.id ||
        this.getLatestVersion(docVersions)?.id ||
        doc?.id ||
        attachment?.id
    },
    getAttachmentVersionObject (attachment, versionId) {
      const docVersions = attachment?.associated_versions || attachment?.core_document?.associated_versions || []
      if (versionId && Array.isArray(docVersions) && docVersions.length) {
        const matched = docVersions.find(version => version?.id === versionId)
        if (matched) return matched
      }
      return this.getAttachmentDocument(attachment)
    },
    enrichDocumentAssociationsWithUser () {
      const currentUser = this.getCurrentUserData()
      this.materialMasterTemp.material_document_associations = (this.materialMasterTemp.material_document_associations || []).map((doc) => {
        if (doc?.core_user?.first_name || doc?.core_user?.last_name) {
          return doc
        }
        return {
          ...doc,
          core_user: currentUser
        }
      })
    },
    materialCustomType () {
      GetMaterialCustomList().then((res) => {
        this.customListType = res.custom_list_values
      })
    },
    handleWorkFlowSelection (workflow) {
      this.selectedWorkFlow = workflow || null
    },
    getWorkflows () {
      this.WFTLoading = true
      getFullWorkFLowTemplates([config.CORE_FEATURES.MATERIAL], '', [config.WORKFLOW_SUB_CATE.PROCESS_PLAN]).then((res) => {
        this.workflows = res.workflow_templates
      }).catch(() => {
        this.workflows = []
      }).finally(() => {
        this.WFTLoading = false
      })
    },
    changeNumber (event) {
      if (['e', 'E', '+', '-'].includes(event.key)) {
        restrictKeys(event)
      }
    },
    validateSetupTimeFields () {
      const hasSetupTimeValue =
        this.materialMasterTemp.setup_time !== null &&
        this.materialMasterTemp.setup_time !== undefined &&
        this.materialMasterTemp.setup_time !== ''
      const hasSetupTimeDurationType =
        this.materialMasterTemp.setup_time_duration_type !== null &&
        this.materialMasterTemp.setup_time_duration_type !== undefined &&
        this.materialMasterTemp.setup_time_duration_type !== ''

      if (hasSetupTimeValue !== hasSetupTimeDurationType) {
        alert('Please provide both Setup Time value and Setup Time unit.')
        return false
      }
      return true
    },
    handleInputChange (data) {
      if (this.materialMasterTemp.core_form) {
        this.metadataPayloadValueMap[data.field_id] = data.value
      }
    },
    async getSTFtempId () {
      if (this.tenantDefaultsData?.material_temp_id) {
        this.templateId = this.tenantDefaultsData.material_temp_id
        return
      }
      const res = await GetTenantConfigTypes()
      const tenantDefaults = res.tenant_defaults?.[0]
      this.$store.commit('setTenentDefaults', tenantDefaults)
      this.templateId = tenantDefaults.tenant_feature_configuration?.MATERIAL.FORM_TEMPLATE_DEFAULT
    },
    async getFormTemplateData () {
      await getDetailFormTemplate(this.templateId).then((res) => {
        this.formTemplateData = res.core_form_templates_by_pk
        const customListData = this.findUsedCustomListIds(res.core_form_templates_by_pk.template_versions)
        if (customListData.size > 0) {
          this.getGivenCustomList([...customListData])
        }
      })
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    async saveForm () {
      const form = this.$refs
      const formValue = {}
      this.validationErrors = []
      let isValid = true // Track if the form is valid
      for (const key of Object.keys(form)) {
        const field = form[key]?.[0]
        const component = field?.data
        if (!component) continue
        this.validateInputData(component, form)
        if (field?.validateSelection) {
          const isSelectionValid = await field.validateSelection()
          if (!isSelectionValid) {
            this.validationErrors.push(`${component.caption} must use a last child selection`)
          }
        }
        if (component?.key === 'TABLE' || component?.form_field?.key === 'TABLE') {
          const isTableValid = await field.saveFormTemplate()
          if (!isTableValid) return false
        }
        if (form[key].length && form[key][0]?.data?.autogenerated === false) {
          formValue[key] = form[key][0].componentValue
        }
      }
      if (this.validationErrors.length > 0) {
        isValid = false
        this.validationErrors.forEach(error => alert(error))
        return
      }
      const inputPayload = []
      if (!this.materialMasterTemp.core_form) {
        Object.keys(formValue).forEach((key) => {
          if (formValue[key] !== undefined && formValue[key] !== null) {
            if (formValue[key] !== 0 && formValue[key].length !== 0) {
              inputPayload.push({
                field_id: key,
                value: formValue[key]
              })
            }
          }
        })
        const body = [{
          templateId: this.templateId,
          dueDate: new Date().toISOString().split('T')[0],
          inputPayload: inputPayload,
          status: 1
        }]
        if (inputPayload.length > 0) {
          const loader = new Loader()
          loader.show()
          SaveFormData(body, this.isOnProjectLevel).then((res) => {
            // this means you are uploading a material custom field form
            if (this.materialMasterTemp.id) {
              const formId = res.insertedFormIds[0]
              this.materialMasterTemp.core_form = { id: formId }
              upadateMaterialForms(this.materialMasterTemp.id, formId)
                .then(() => {
                  loader.hide()
                })
            }
          })
        }
      } else {
        const metadataPayload = []
        for (const [key, value] of Object.entries(this.metadataPayloadValueMap)) {
          metadataPayload.push({ field_id: key, value })
        }
        const payload = {
          formId: this.materialMasterTemp.core_form.id,
          metadataPayload
        }
        if (metadataPayload.length > 0) {
          const loader = new Loader()
          loader.show()
          EditForm(payload).then(() => {
            loader.hide()
          })
        }
      }
      return isValid
    },
    async save () {
      if (this.isSaving) return
      this.isSaving = true
      const loader = new Loader()
      try {
        if (!await this.validateTagSelections()) {
          return
        }
        if (!this.validateSetupTimeFields()) {
          return
        }
        if (!MaterialMasterValidation(this.materialMasterTemp)) {
          return
        }
        const res = await checkForAnyRunningInstances(this.materialMasterTemp.id)
        if (res?.job_order_material_links?.length) {
          alert('Item in JO form can’t be modified')
          return
        }
        const isFormValid = await this.saveForm()
        if (!isFormValid) {
          return
        }
        loader.show()
        this.materialMasterTemp.tag_materials = this.tagGroupData?.tagArray?.flat(1).map(tag => {
          return {
            tag: {
              id: tag.id,
              name: tag.name,
              parent_id: tag.parentId
            }
          }
        })
        const updateObj = {
          id: this.materialMasterTemp.id,
          type: this.materialMasterTemp.type,
          gross_weight: this.disabledFields.includes('gross_weight') ? this.materialMaster.gross_weight : this.materialMasterTemp.gross_weight,
          lead_time: this.materialMasterTemp.lead_time,
          material_description: this.materialMasterTemp.material_description,
          material_name: this.materialMasterTemp.material_name,
          effective_date: this.materialMasterTemp.effective_date,
          storage_loc: this.materialMasterTemp.storage_loc,
          unit_cost: this.materialMasterTemp.unit_cost,
          unit_of_material: this.disabledFields.includes('unit_of_material') ? this.materialMaster.unit_of_material : this.materialMasterTemp.unit_of_material,
          unit_sale_price: this.materialMasterTemp.unit_sale_price,
          weight_unit: this.disabledFields.includes('weight_unit') ? this.materialMaster.weight_unit : this.materialMasterTemp.weight_unit,
          product_code: this.materialMasterTemp.product_code,
          // plm_record_id: this.disabledFields.includes('plm_record_id') ? this.materialMaster.plm_record_id : this.materialMasterTemp.plm_record_id,
          plm_material_id: this.disabledFields.includes('plm_material_id') ? this.materialMaster.plm_material_id : this.materialMasterTemp.plm_material_id,
          workflow_template_id: this.selectedWorkFlow ? this.selectedWorkFlow.id : null
          // parent_id: this.materialMasterTemp.parent_id
        }

        if (this.materialMasterTemp.type === this.materialTypeIdMap.material) {
          updateObj.material_group = this.materialMasterTemp.material_group
          // updateObj.resource_type = null
        } else {
          // updateObj.resource_type = this.materialMasterTemp.resource_type
          updateObj.setup_time = this.materialMasterTemp.setup_time
          updateObj.setup_time_duration_type = this.materialMasterTemp.setup_time_duration_type
          updateObj.material_group = null
        }

        await UpdateMaterialMasterData(updateObj)
        const productCodeSequenceInput = this.getProductCodeSequenceInput()
        if (productCodeSequenceInput) {
          const productCodeRes = await CreateLinkProductCode({
            material_id: this.materialMasterTemp.id,
            product_code_sequence_template_id: this.sequenceIdForProductCode,
            product_code_sequence_input: productCodeSequenceInput
          })
          const linkedProductCode = productCodeRes?.CreateLinkProductCode
          this.materialMasterTemp.product_code = linkedProductCode?.product_code_id || linkedProductCode?.inserted_product_code_id || this.materialMasterTemp.product_code
          this.materialMasterTemp.material_product_code = {
            ...(this.materialMasterTemp.material_product_code || {}),
            id: this.materialMasterTemp.product_code,
            product_code: this.materialMasterTemp.productCodeName
          }
        }

        await this.updateDocAttchments()
        if (this.tagGroupData.tagArray) {
          const currentTagIds = new Set(
            this.tagGroupData.tagArray.flat(1).map(tag => tag.id)
          )
          const existingTagIds = new Set(
            (this.materialMaster.tag_materials || []).map(item => item.tag.id)
          )

          const tagsToDelete = [...existingTagIds].filter(tagId => !currentTagIds.has(tagId))
          const tagsToAdd = [...currentTagIds].filter(tagId => !existingTagIds.has(tagId))

          if (tagsToDelete.length > 0) {
            await DeleteMaterialTagsByTagIds(updateObj.id, tagsToDelete)
          }
          if (tagsToAdd.length > 0) {
            const tagMaterials = tagsToAdd.map(tagId => ({
              tag_id: tagId,
              material_id: updateObj.id
            }))
            await AddMaterialTags(tagMaterials)
          }
        }
        this.materialMaster.type === 1 ? success('Material Master Data updated successfully') : success('Resource Master Data updated successfully')
        // success('Material Master Data updated successfully')
        loader.hide()
        this.materialMasterTemp.material_unit_details = {
          name: this.list_of_unit_of_material.filter((element) => {
            if (element.id === this.materialMasterTemp.unit_of_material) {
              return element.name
            }
          })[0]?.name,
          id: this.materialMasterTemp.unit_of_material
        }
        if (this.materialMasterTemp.material_product_code?.id || this.materialMasterTemp.material_product_code?.product_code) {
          this.materialMasterTemp.material_product_code = {
            ...(this.materialMasterTemp.material_product_code || {}),
            product_code: this.materialMasterTemp.productCodeName
          }
        }
        this.materialMasterTemp.material_weight_details = {
          name: this.list_of_weight_unit.filter((element) => {
            if (element.id === this.materialMasterTemp.weight_unit) {
              return element.name
            }
          })[0]?.name,
          id: this.materialMasterTemp.weight_unit
        }
        this.materialMasterTemp.material_group_details = {
          name: this.list_of_material_group.filter((element) => {
            if (element.id === this.materialMasterTemp.material_group) {
              return element.name
            }
          })[0]?.name,
          id: this.materialMasterTemp.material_group
        }
        this.materialMasterTemp.resource_type_details = {
          name: this.list_of_material_group.filter((element) => {
            if (element.id === this.materialMasterTemp.resource_type) {
              return element.name
            }
          })[0]?.name,
          id: this.materialMasterTemp.resource_type
        }
        this.materialMasterTemp.resource_type_value = {
          name: this.list_of_material_group.filter((element) => {
            if (element.id === this.materialMasterTemp.resource_type) {
              return element.name
            }
          })[0]?.name,
          id: this.materialMasterTemp.resource_type
        }
        this.materialMasterTemp.material_type_value = {
          name: this.customListType.filter((element) => {
            if (element.id === this.materialMasterTemp.material_type) {
              return element.name
            }
          })[0]?.name,
          id: this.materialMasterTemp.material_type
        }
        this.materialMasterTemp.workflow_template = this.selectedWorkFlow ? {
          id: this.selectedWorkFlow.id,
          name: this.selectedWorkFlow.name
        } : null
        this.enrichDocumentAssociationsWithUser()
        const latestMaterialRes = await GetSingleMaterialMasterData({ id: this.materialMasterTemp.id })
        const latestMaterial = latestMaterialRes?.core_material_master?.[0]
        if (latestMaterial) {
          latestMaterial.material_type_value = this.materialMasterTemp.material_type_value
          latestMaterial.resource_type_value = this.materialMasterTemp.resource_type_value
          latestMaterial.material_type = this.materialMasterTemp.material_type
        }
        this.$emit('updateAndClose', latestMaterial || this.materialMasterTemp)
      } catch (err) {
        const graphQLErrmessage = err.graphQLErrors[0].message

        if (err.message.includes('unique_product_code_validation') || graphQLErrmessage === 'Product code already exists') {
          alert('Product Code already exists. Please enter a unique Product Code.')
        } else if (err.message.includes('core_material_master_custom_material_id_tenant_id_key')) {
          alert('Material ID Already exists!')
        } else if (err.message.includes('tag_material_pkey')) {
          alert('Tag Already attached!')
        } else {
          console.log(err)
          alert('Something went wrong')
        }
        loader.hide()
      } finally {
        this.isSaving = false
      }
    },
    resetForm () {
      this.materialMaster = {}
    },
    toggleMore () {
      this.moreInput = !this.moreInput
    },
    listOfUnitOfMaterial () {
      UnitOfMaterial().then((res) => {
        this.list_of_unit_of_material = res.custom_list_values.map((item) => {
          if (item.name === 'Hours (hrs)') {
            this.resourceUnit = item
            if (this.materialMasterTemp.type === 2) {
              this.materialMasterTemp.unit_of_material = item.id
            }
          }
          return {
            name: item.name,
            id: item.id
          }
        }).filter(
          unit => unit.name !== 'Hours (hrs)'
        )
      })
    },
    listOfWeightUnit () {
      WeightUnit().then((res) => {
        this.list_of_weight_unit = res.custom_list_values.map((item) => {
          return {
            name: item.name,
            id: item.id
          }
        })
      })
    },
    async getFormData () {
      this.loading = true
      if (this.materialMasterTemp.core_form) {
        try {
          const res = await GetFormDataByFormId(
            this.materialMasterTemp.core_form.id,
            this.isOnProjectLevel
          )
          this.formData = res.core_forms_by_pk
          const { formValueMap } = GetFormValueMap(res.core_forms_by_pk)
          this.formValueData = { ...formValueMap }
        } catch (e) {
          console.error(e)
        } finally {
          this.loading = false
        }
      }
    },
    listOfMaterialGroup () {
      if (this.view === 'material') {
        this.materialName = 'Material Group'
        ResourceGroup(this.materialName).then((res) => {
          this.list_of_material_group = res.custom_list_values.map((item) => {
            return {
              name: item.name,
              id: item.id
            }
          })
        })
      } else {
        getResourceTypes().then((res) => {
          this.list_of_material_group = res.custom_list_values.map((item) => {
            return {
              name: item.name,
              id: item.id
            }
          })
        })
      }
    },
    listOfAddressLocation () {
      AddressLocation().then((res) => {
        this.list_of_address_location = res.address_locations
      })
    },
    handleFileSelection (selectedFileData) {
      // the selectedfiles data is comming from modal (contains  all the datat related to selected docs)
      this.documentSelectDialog = false
      this.materialMasterTemp.material_document_associations = selectedFileData
    },
    async updateDocAttchments () {
      const addnewAttachments = []
      const deleteAttachments = []
      const normalizedAssociations = []
      this.materialMasterTemp.material_document_associations.forEach((element) => {
        const documentId = this.getAttachmentDocumentId(element)
        const versionId = this.getAttachmentVersionId(element)
        if (element.flag !== 'deleted') {
          const versionDoc = this.getAttachmentVersionObject(element, versionId)
          normalizedAssociations.push({
            ...element,
            material_id: this.materialMasterTemp.id,
            document_id: documentId,
            version_id: versionId,
            core_document_version: versionDoc
          })
        }
        if (element.flag === 'new') {
          addnewAttachments.push({
            material_id: this.materialMasterTemp.id,
            document_id: documentId,
            version_id: versionId
          })
        } else if (element.flag === 'deleted') {
          deleteAttachments.push(documentId)
        }
      })
      addnewAttachments.length > 0 && await attachDocToMaterail(addnewAttachments)
      deleteAttachments.length > 0 && await removeAttachments(this.materialMasterTemp.id, deleteAttachments)
      this.materialMasterTemp.material_document_associations = normalizedAssociations.map((association) => {
        delete association.flag
        return association
      })
    },
    getAttachedTags () {
      this.attachedTags = this.$props.materialMaster.tag_materials.map(item => {
        return {
          id: item.tag.id,
          name: item.tag.name,
          parentId: item.tag.parent_id
        }
      })
      this.tagTrie._generateTreeFromUnorderedList(this.attachedTags)
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    removeAttachedTags (tagId) {
      this.tagTrie.deleteTagById2(tagId)
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    sethoveredtag (cindex, index) {
      this.hoverd_tag.cindex = cindex
      this.hoverd_tag.index = index
    },
    normalizeRowPayload (payload) {
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        return payload
      }
      return { id: payload, rowIndex: this.selected_tag_line }
    },
    addnewTag (payload) {
      const { tag, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      if (!tag) return
      this.tagTrie.insertTag({ name: tag.name, id: tag.id, parentId: tag.parentId ?? tag.parent_id })
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    changeSelectedTagLine (payload) {
      const { id, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      if (id === null) {
        if (typeof rowIndex !== 'number') this.selected_tag_line = 0
      } else {
        this.tagGroupData.tagArray.forEach((element, index) => {
          if (element[0].id === id) { this.selected_tag_line = index }
        })
      }
    },
    resetSelectedTagLine (payload) {
      const { rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      const currentLine = this.tagGroupData?.tagArray?.[this.selected_tag_line] || []
      if (currentLine.length) {
        this.tagTrie.deleteTagById2(currentLine[0].id)
        this.tagGroupData = this.tagTrie.groupTagInArray()
      }
      this.selected_tag_line = 0
    },
    focusTagLevel (payload) {
      const { index, rowIndex } = this.normalizeRowPayload(payload)
      if (typeof rowIndex === 'number') {
        this.selected_tag_line = rowIndex
      }
      const currentLine = this.tagGroupData?.tagArray?.[this.selected_tag_line] || []
      if (!currentLine.length || typeof index !== 'number') return
      const tagsToRemove = currentLine.slice(index)
      for (let i = tagsToRemove.length - 1; i >= 0; i--) {
        this.tagTrie.deleteTagById2(tagsToRemove[i].id)
      }
      this.tagGroupData = this.tagTrie.groupTagInArray()
    },
    keyPress (e) {
      const activeElement = this.window.document.activeElement.tagName.toLowerCase()
      const activeElementCheck = ['input', 'select', 'textarea'].includes(activeElement)
      if (e instanceof KeyboardEvent && e.code === 'Enter' && activeElement !== 'button') {
        this.window.document.activeElement.blur()
      }
      if (this.buttonDisabled || activeElementCheck) {
        return
      }
      if (e instanceof KeyboardEvent && e.code === 'Enter') {
        this.save()
      }
    },
    async validateTagSelections () {
      if (!this.$refs.tagSelector?.validateSelection) return true
      const isValid = await this.$refs.tagSelector.validateSelection()
      if (!isValid) {
        alert('Please select the last child tag before continuing.')
      }
      return isValid
    },
    validateInputData (formInput, form) {
      const componentValue = form[formInput.field_id]?.[0]?.componentValue

      if (formInput?.form_field?.key === 'USER') {
        if (formInput.required && (!componentValue || !componentValue.length)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
      }
      if (formInput?.form_field?.key === 'BOOLEAN') {
        // we are comparing the value to null instead of checking if it is a falsy value cause the boolean component value will false in one case and it is valid value
        if (formInput.required && componentValue === null) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
        return
      } else if (Array.isArray(componentValue)) {
        if (formInput.required && componentValue.length < 1) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
        return
      }
      if (formInput.required && !componentValue) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
      }
    }
  },
  watch: {
    'materialMasterTemp.type' () {
      if (Number(this.materialMasterTemp?.type) === 2) {
        this.materialMasterTemp.unit_of_material = this.resourceUnit.id
      }
    }
  },
  async mounted () {
    const tenantDefaults = await getTenantDefaults()
    this.productCodeFeatureSeq = tenantDefaults.tenant_defaults[0].tenant_feature_configuration?.PRODUCT_CODE?.SEQUENCE_TEMPLATE_DEFAULT
    this.initializeProductCodePreview()
    if (this.materialMaster.workflow_template) {
      this.selectedWorkFlow = this.materialMaster.workflow_template
    }
    this.listOfUnitOfMaterial()
    this.listOfWeightUnit()
    this.listOfMaterialGroup()
    this.listOfAddressLocation()
    this.getAttachedTags()
    this.getWorkflows()
    this.materialCustomType()
    await this.getSTFtempId()
    if (this.templateId) {
      await this.getFormTemplateData()
    }
    this.getFormData()
  },
  created () {
    this.getSTFtempId()
    if (this.templateId) {
      this.getFormTemplateData()
    }
    document.body.addEventListener('keydown', this.keyPress)
    this.materialMasterTemp = JSON.parse(JSON.stringify(this.materialMaster))
    this.productCode = this.hasExistingProductCode
    this.materialType = config.MATERIAL_TYPES
    this.materialMasterTemp.productCodeName = this.materialMasterTemp.material_product_code?.product_code
    if (this.materialMasterTemp.resource_type_value?.id) {
      this.materialMasterTemp.resource_type = this.materialMasterTemp.resource_type_value.id
    }
    if (this.materialMasterTemp.material_source?.id === 1) {
      this.disabledFields.push('unit_of_material', 'gross_weight', 'weight_unit')
    } else if (this.materialMasterTemp.material_source?.id === 2) {
      this.disabledFields.push('unit_of_material', 'gross_weight', 'weight_unit')
    } else if (this.materialMasterTemp.material_source?.id === 3) {
      this.disabledFields.push('unit_of_material', 'gross_weight', 'weight_unit', 'plm_material_id')
    }
    this.disabledFields.push('erp_material_id')
  },
  beforeDestroy () {
    document.body.removeEventListener('keydown', this.keyPress)
  }
}
</script>

<style lang="scss" scoped >
.material-master-edit {
  width: 600px;
  max-height: 70vh;
  padding-right: 5px;
  overflow-y: auto;
  .document-attach{
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    width: 100%;
    max-height: 100px;
    min-height: 50px;
    // border-radius: 4px;
    // border: 2px solid rgba(var(--brand-rgb),0.4);
    cursor: pointer;
    &-view{
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

    }
    &-edit{
      border: 2px solid rgba(41, 39, 39, 0.2);
      border-radius: 3px;
      padding: 4px 6px;
      width: 25px;
      display: flex;
      justify-content: center;
      margin-left: 5px;
    }
    &-list{
      border: 2px solid rgba(var(--brand-rgb));
      border-radius: 3px;
      padding: 5px 5px 5px 5px ;
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    }
    span{
      cursor: pointer;
      user-select: none;
      background-color: transparent;
    }
  }
      .form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 15px 8px;
    align-items: start;
  }
  .form-grid__item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    &:last-child{
      margin-bottom: 1rem;
    }
  }
  .form-grid__item--span-2 {
    grid-column: span 2;
  }
}
.tags {
  display: flex;
flex-wrap: wrap;
margin-left: 5px;
  margin-right: 5px;
  row-gap: 5px;
   &-line-selected{
    background-color: var(--brand-light-color);
   border: .4px solid var(--brand-color);
   border-radius: 5px;
   min-width: min-content;
   }
}
.tag-container {
  margin-top: 4px;
}

.no-tag-found{
  margin-left: 5px;
}
.attached-tags{
  cursor:pointer;
  background-color: var(--brand-color);
  padding: 0.6rem;
  font-size: small;
  border-radius: 0.4rem;
position:relative;
  &-fade{
background-color: rgb(0, 0,0,.6) ;
color:white
}
  & img{
 z-index:4;
  }
  & img{
    display: none;
  }
}
.tags-line{
  text-overflow: ellipsis;
  overflow: hidden;
   white-space: nowrap;
  & img{
    margin-inline: .5rem;
  }
  &-first-img{
    display: none;
  }
  .attached-tags:hover > img {
display: block;
scale: 1.2;
// -webkit-box-shadow:0px 0px 123px 21px rgba(215,224,221,0.78);
// -moz-box-shadow: 0px 0px 123px 21px rgba(215,224,221,0.78);
// box-shadow: 0px 0px 123px 21px rgba(215,224,221,0.78);
  }
  .attachedTags_overLay{
    background-color: black;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    opacity: .3;
    z-index: 1;
  }
}
</style>
